import { $t } from '@/i18n';
import { defineComponent, ref } from '@vue/composition-api';
import ModalFactory from '@/utils/modalFactory';
const editorDisconnectModal = defineComponent({
    name: 'editorDisconnectModal',
    emits: ['message'],
    setup(_props, { emit }) {
        const visible = ref(true);
        const handleOk = () => {
            emit('message', {
                success: true,
            });
        };
        const handleCancel = () => {
            emit('message', {
                success: false,
                message: 'cancel',
            });
        };
        return {
            visible,
            handleOk,
            handleCancel,
        };
    },
    render() {
        return (<t-dialog width="450px" visible={this.visible} header={$t('k_a6f1b0f4')} closeBtn={false} onCancel={this.handleCancel} closeOnOverlayClick={false}>
        <p class="mb-1">{$t('k_27c2888e')}</p>
        <p class="m-0">{$t('k_6dcc9c5c')}</p>
        <div slot='footer' class="flex flex-justify-end gap-1">
          <t-button onClick={this.handleOk}>
            {$t('k_c14c8fff')}
          </t-button>
          <t-button theme="default" onClick={this.handleCancel}>{$t('k_5db66351')}</t-button>
        </div>
      </t-dialog>);
    },
});
export default ModalFactory(editorDisconnectModal);
